<template>
  <!-- eslint-disable -->
  <div class="contracts-users">
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6">
          <!-- Contracts -->
          <v-card>
            <v-card-title>Contracts</v-card-title>
            <div class="mb-3" v-for="(contract, i) in modelContracts" :key="contract.id">
              <v-card>
                <v-card-subtitle>{{ contract.name }}</v-card-subtitle>
                <div class="pb-3 px-3">
                  <v-sheet light>
                    <div style="max-height: 40vh; overflow: scroll;">
                      <json-editor :obj-data="contract.config" v-model="modelContracts[i].config"></json-editor>
                    </div>
                  </v-sheet>
                  <div class="my-3 text-end">
                    <v-btn small light @click="onSaveContractBlock(contract.id)">SAVE</v-btn>
                  </div>
                </div>
              </v-card>
            </div>
          </v-card>
        </v-col>
        <!-- Users/Contacts -->
        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title>Contacts</v-card-title>
            <v-card-text>
              <div class="mb-5">
                <template v-if="create_user_form_on === false">
                  <v-btn light @click="create_user_form_on = true;">CREATE</v-btn>
                </template>
                <template v-else>
                  <v-row no-gutters align="center">
                    <v-col cols="12" sm="4">
                      <v-text-field label="Email" class="mr-2" prepend-inner-icon="mdi-email" hide-details="true" ref="newUserEmail" dense outlined v-model="formNewUser.email"></v-text-field>
                    </v-col>
                    <v-col class="d-flex justify-start">
                      <v-btn light @click="" class="mr-2" @click="onCreateUser">CREATE</v-btn>
                      <v-btn color="red" @click="create_user_form_on = false;">CANCEL</v-btn>
                    </v-col>
                    <v-col>
                    </v-col>
                  </v-row>
                </template>
              </div>
              <div class="mb-3">
                <v-checkbox v-model="manage_archived_users" label="Manage archived users" hide-details></v-checkbox>
              </div>
              <div>
                <v-data-iterator :items="modelUsers" :options="{ itemsPerPage: 1000 }" hide-default-footer>
                  <template #default="props">
                    <template v-for="(u, i) in props.items">
                      <v-row v-if=" ! u.ui.is_archived || manage_archived_users" align="center" :key="`u_${u.id}}`">
                        <v-col cols="12" sm="4">
                          <div v-if="manage_archived_users" class="mb-1">
                            <v-switch label="Archived" v-model="u.ui.is_archived" dense hide-details></v-switch>
                          </div>
                          <v-text-field label="" prepend-inner-icon="mdi-account" hide-details="true" dense outlined v-model="props.items[i].name" class="mb-1"></v-text-field>
                          <v-text-field label="" prepend-inner-icon="mdi-email" hide-details="true" dense outlined v-model="props.items[i].email"></v-text-field>
                          <div class="pl-1">
                            <span class="caption" v-if="u.third_party_code">{{ u.third_party_code }}</span>
                            <span class="overline" v-else>UNCLAIMED</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <v-switch label="Contractor" v-model="u.ui.is_contractor"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-select
                            dense
                            v-model="u.ui.contract_ids"
                            :items="contracts"
                            item-text="name"
                            item-value="id"
                            small-chips
                            label="Contracts"
                            multiple
                            outlined
                            hide-details="true"
                          >
                          </v-select>
                        </v-col>
                        <v-col>
                          <v-btn small light @click="onSaveUserBlock(u.id)">SAVE</v-btn>
                        </v-col>
                      </v-row>
                    </template>
                  </template>
                </v-data-iterator>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>
    </v-container>
    <v-card class="elevation-0" ref="container">
      <v-card-text>
        <v-overlay :value="loading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div
          :style="`max-height: ${scrollableHeight}px`"
          class="overflow-y-auto"
        >
          <!-- <json-editor :obj-data="form.configJSON" v-model="form.configJSON" /> -->
        </div>
        <!-- <v-btn class="mt-5" color="primary" @click="saveConfig">SAVE</v-btn> -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import _ from "lodash/lodash";
import { FirmService } from "@/services/firm.service";
import { UserService } from "@/services/user.service";
import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { ContractService } from "@/services/contract.service";

export default {
  name: 'ContractsUsers',
  data: () => ({
    users: [],
    contracts: [],
    modelUsers: [], // tweaked for use as v-models
    modelContracts: [], // tweaked for use as v-models
    loading: false,
    scrollableHeight: 0,
    formNewUser: { email: '' },
    create_user_form_on: false,
    manage_archived_users: false,
  }),
  computed: {
    //
  },
  watch: {
    create_user_form_on: function(on) {
      if (on) {
        this.$nextTick(() => {
          // Note, we need to use a ref for the input hidden
          // inside the <v-text-field> we assign a ref to.
          this.$refs.newUserEmail.$refs.input.focus();
        });
      }
    }
  },
  mounted() {
    this.refreshRouteData();
  },
  methods: {
    reset() {
      this.users = [];
      this.contracts = [];
    },
    async refreshRouteData() {
      let data;
      try {
        this.reset();
        this.loading = true;
        const all = await this.getRouteData();
        const { contracts, users } = all;
        this.modelContracts = this.makeModelContracts(contracts);
        this.modelUsers = this.makeModelUsers(users);
        this.contracts = contracts;
        this.users = users;
      }
      catch(err) {
        console.log(err);
      }
      finally {
        this.setScrollableHeight();
        this.loading = false;
        return data;
      };
    },
    async getRouteData() {
      try {
        const auth_firm_id = this.$store.state.auth.user.firm_id;
        const users = await UserService.all({ include: 'contracts' }).then(r => denormalize(r.data))
        const contracts = await FirmService.getContracts(auth_firm_id).then(r => denormalize(r.data));
        return {
          contracts,
          users,
        };
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    setScrollableHeight() {
      setTimeout(() => {
        const containerHeight = this.$refs.container.$el.clientHeight;
        this.scrollableHeight = containerHeight - 32 - 56;
      }, 500);
    },
    makeModelUsers(users) {
      let transformed = [];
      users.forEach(user => {
        let u = Object.assign({}, user);
        u.ui = {
          is_archived: user.archivedAt ? true : false,
          is_contractor: (
            ! user.firm_id
            || user.firm_id != this.$store.state.auth.user.firm_id
          ),
          contract_ids: user.contracts.map(c => {
            return c.id;
          }),
        };
        transformed.push(u);
      });
      // Sort by "has contract or not" and then by name
      return _.sortBy(transformed, [
        o => o.ui.contract_ids.length == 0 ? 0 : 1,
        o => o.name
      ]);
    },
    makeModelContracts(contracts) {
      let transformed = [];
      contracts.forEach(contract => {
        transformed.push(Object.assign({}, contract));
      });
      return _.sortBy(transformed, 'name');
    },
    async onSaveUserBlock(user_id) {
      this.loading = true;
      try {
        // Get data from model
        const model = this.modelUsers.find(u => {
          return (u.id == user_id);
        });
        let userPayload = {
          name: model.name,
          email: model.email,
          firm_id: model.ui.is_contractor
            ? null
            : this.$store.state.auth.user.firm_id,
        };
        if (this.manage_archived_users) {
          userPayload.is_archived = model.ui.is_archived ? 1 : 0;
        }
        const contractIdsPayload = {
          contract_ids: model.ui.contract_ids,
        };
        const update1 = await this.updateUser(user_id, userPayload);
        const update2 = await this.syncUserContracts(user_id, contractIdsPayload);
        this.$store.commit('snacktime', {
          text: 'Details saved successfully.'
        });
        await this.refreshRouteData();
        this.loading = false;
      }
      catch (err) {
        console.log(err);
      }
      finally {
        this.loading = false;
      }
    },
    async updateUser(user_id, changes) {
      const user = await new Promise((resolve, reject) => {
        // Only update if changes detected.
        let u = this.users.find(o => {
          return o.id == user_id;
        });
        const currentValues = _.pick(u, Object.keys(changes));
        if (_.isEqual(currentValues, changes)) {
          console.log("[NO_UPDATE] No change to user data detected.");
          return resolve(u);
        }
        else {
          UserService.update(u.id, changes).then(r => {
            u = denormalize(r.data);
            return resolve(u);
          })
          .catch(err => {
            return reject(err);
          });
        }
      });
      return user;
    },
    async syncUserContracts(user_id, payload) {
      const user = await new Promise((resolve, reject) => {
        // Only update if changes detected.
        let u = this.users.find(o => {
          return o.id == user_id;
        });
        let prev_contract_ids = u.contracts.map(c => {
          return c.id;
        });
        let next_contract_ids = payload.contract_ids;
        prev_contract_ids.sort();
        next_contract_ids.sort();
        if (_.isEqual(prev_contract_ids, next_contract_ids)) {
          console.log("[NO_UPDATE] No change to user's assigned contract IDs detected.");
          return resolve(u);
        }
        else {
          UserService.syncContracts(u.id, next_contract_ids).then(r => {
            u = denormalize(r.data);
            return resolve(u);
          })
          .catch(err => {
            return reject(err);
          });
        }
      });
      return user;
    },
    async onCreateUser() {
      try {
        this.loading = true;
        const user = await UserService.create({ email: this.formNewUser.email }).then(r => r.data);
        this.create_user_form_on = false;
        this.formNewUser.email = '';
        this.$store.commit('snacktime', {
          text: 'User created successfully.'
        });
      }
      catch (err) {
        console.log(err);
      }
      finally {
        this.loading = false;
        this.refreshRouteData();
      }
    },
    async onSaveContractBlock(contract_id) {
      const contractModel = this.modelContracts.find(c => {
        return (c.id == contract_id);
      });
      const { config } = contractModel;
      try {
        this.loading = true;
        const contract = await ContractService.update(contract_id, { config }).then(r => denormalize(r.data));
        this.$store.commit('snacktime', {
          text: 'Contract updated successfully.'
        });
        this.refreshRouteData();
      }
      catch (err) {
        console.log(err);
      }
      finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style lang="scss">
.config {
  height: 100%;

  .v-card {
    height: 100%;

    .v-card__text {
      height: 100%;
    }
  }
}
</style>
